import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { formatSeconds } from '@playbookux/playbook-web-core';

import {
  Container,
  ContainerChart,
  ContainerAverage,
  Chart,
  AverageText,
} from './styles';
import BarChart from '../../../../../../../core/components/charts/bar-chart';

import BaseChartCard from '../base-chart-card';
import TranscriptChart from '../transcript-chart';

const TimeOnQuestion = (props) => {
  const {
    projectId,
    data,
    averageTime,
  } = props;

  const [chart, setChart] = useState({});

  useEffect(() => {
    const timeOnAnswer = data.map((item) => item.timeOnAnswer);
    setChart({
      labels: data.map((item) => item.firstName),
      datasets: [{
        hidden: false,
        backgroundColor: '#407CD1',
        data: timeOnAnswer,
      }],
    });
  }, [data]);

  const onBarClicked = (value) => {
    if (!value) {
      return;
    }
    const { _index: index } = value;

    window.open(`/projects/${projectId}/videos/${data[index].testerId}?time=${data[index].videoStartTime}`, '_blank');
  };

  return (
    <Container>
      <BaseChartCard
        isTimeOnQuestion
      >
        <ContainerChart>
          <Chart>
            <BarChart
              data={chart}
              height={350}
              onBarClicked={onBarClicked}
              stepSize={2}
              type="horizontal"
              xAxesLabel="seconds"
              xAxesFormater={(value) => formatSeconds(value)}
            />
          </Chart>
          <ContainerAverage>
            <AverageText>Average Time</AverageText>
            <AverageText>{averageTime}</AverageText>
          </ContainerAverage>
        </ContainerChart>
      </BaseChartCard>
      <TranscriptChart
        projectId={projectId}
        data={data}
      />
    </Container>
  );
};

TimeOnQuestion.propTypes = {
  projectId: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    testerId: PropTypes.string.isRequired,
    videoStartTime: PropTypes.number.isRequired,
  })).isRequired,
  averageTime: PropTypes.string.isRequired,
};

export default TimeOnQuestion;
